import {
  enable_promptbook_onboarding_flag,
  enable_promptbook_result_panel_flag,
  enable_promptbook_process_tab_flag,
  enable_promptbook_status_bar_flag,
  enable_promptbook_variables_flag,
  enable_visualization_config_download_flag,
  enable_promptbook_metric_highlights_flag,
} from "@/services/posthog/feature_flags";
import { FeatureFlag } from "@pufflig/promptbook-editor";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useMemo } from "react";

export const usePromptbookFeatureFlags = () => {
  const featureFlags: Partial<Record<FeatureFlag, boolean>> = {};
  const visualizationConfigDownloadEnabled = useFeatureFlagEnabled(enable_visualization_config_download_flag);
  const resultsPanelEnabled = useFeatureFlagEnabled(enable_promptbook_result_panel_flag);
  const processTabEnabled = useFeatureFlagEnabled(enable_promptbook_process_tab_flag);
  const variableEnabled = useFeatureFlagEnabled(enable_promptbook_variables_flag);
  const onboardingEnabled = useFeatureFlagEnabled(enable_promptbook_onboarding_flag);
  const statusbarEnabled = useFeatureFlagEnabled(enable_promptbook_status_bar_flag);
  const metricHighlightsEnabled = useFeatureFlagEnabled(enable_promptbook_metric_highlights_flag);

  featureFlags[enable_promptbook_metric_highlights_flag] = metricHighlightsEnabled || false;
  featureFlags[enable_visualization_config_download_flag] = visualizationConfigDownloadEnabled || false;
  featureFlags[enable_promptbook_result_panel_flag] = resultsPanelEnabled || false;
  featureFlags[enable_promptbook_variables_flag] = variableEnabled || false;
  featureFlags[enable_promptbook_onboarding_flag] = onboardingEnabled || false;
  featureFlags[enable_promptbook_status_bar_flag] = statusbarEnabled || false;

  return useMemo(
    () => featureFlags,
    [
      visualizationConfigDownloadEnabled,
      resultsPanelEnabled,
      processTabEnabled,
      variableEnabled,
      onboardingEnabled,
      statusbarEnabled,
    ],
  );
};
